/*
获取协会基本信息
*/ 
import request from '@/api/request'

// 获取协会token
export async function getToken(params) {
  return await request({
    url: `/code-api/smallProApi/tokenConfig/getAssocTokenByH5`,
    method: 'GET',
    params
  })
}

// 获取协会基本信息
export async function getassocInfo() {
  return await request({
    url: `/code-api/webserver/web/info`,
    method: 'GET',
  })
}


// WEBPACK FOOTER //
// ./src/api/assocInfo.js